import axios from "axios";

// new

// new
const requestFormatList = format => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/admin/format/format-page`,
    format
  );
};

export { requestFormatList };
